import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { get_size_in_bytes_number } from '@shared/utils/utils_files';
import { log_network_event } from '@shared/utils/utils_logs';

export function try_log_server_to_client(event: string, data: Uint8Array) {
  if (!CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) return;
  if (CONSTANTS__shared.NETWORK_EVENTS_AUTOMATED.includes(event)) return;

  let bytes = get_size_in_bytes_number(data);

  log_network_event('🔔 s → c', event, bytes, {
    namespace: ELoggerNamespaceShared.SERVER_TO_CLIENT,
    client_id: CONSTANTS__client.LOGGER_USER_ID,
    log_time_diff_show: true,
  });
}
